export default __webpack_public_path__ + "static/media/LEVEL14.099be58f.png";